<template>
  <div id="common-filters">
    <div class="common-filters-header items-flex">
      <div class="filters-flex">
        <v-btn
          class="elevation-0 button-show-filters mr-2 px-2"
          small
          :color="
            filtersCleaned
              ? $vuetify.theme.dark
                ? 'dark_backgroundLighterBlack'
                : 'softBackgroundGrey'
              : $vuetify.theme.dark
              ? 'dark_backgroundDarkBlue'
              : 'softPrimary'
          "
          @click="toggleFilters"
        >
          <v-icon size="18">mdi-filter-outline</v-icon>
          <span v-if="!mdAndDown" class="mx-1">
            {{ $t('views.common.commonFilters.showFilters') }}
          </span>
          <span v-if="!filtersCleaned && filtersNumber" class="ml-1">
            <b>({{ filtersNumber }})</b>
          </span>
          <v-icon class="ml-0 mr-0" size="22">
            {{ showFilters ? 'mdi-menu-up' : 'mdi-menu-down' }}
          </v-icon>
        </v-btn>

        <!-- si es desktop, aparece arriba, si es movil dentro de los filters -->
        <template v-if="!mdAndDown">
          <v-chip-group v-model="dateSelected" active-class="primary" mandatory class="ml-3" column>
            <v-chip
              v-for="dateFilter in dateFilters"
              :key="dateFilter.value"
              :value="dateFilter.value"
              outlined
            >
              {{ dateFilter.text }}
            </v-chip>
          </v-chip-group>
        </template>
      </div>
      <div class="common-filters-add-button slot-flex">
        <slot name="add-button"></slot>
      </div>
    </div>

    <div v-if="showFilters">
      <template v-if="mdAndDown">
        <v-chip-group
          v-model="dateSelected"
          active-class="primary"
          mandatory
          class="my-1"
          :show-arrows="!isMobile"
        >
          <v-chip
            v-for="dateFilter in dateFilters"
            :key="dateFilter.value"
            :value="dateFilter.value"
            outlined
          >
            {{ dateFilter.text }}
          </v-chip>
        </v-chip-group>
      </template>
      <v-row class="filters-row">
        <v-col cols="12" md="3" class="mt-0 pt-0">
          <v-menu
            v-model="dateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
            content-class="elevation-1"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="dateRangeText"
                :label="$t('views.common.commonFilters.filter.dateRange')"
                readonly
                v-bind="attrs"
                hide-details
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dates"
              no-title
              range
              first-day-of-week="1"
              class="mt-1 mb-0"
              @input="dateSelected = 'custom'"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col
          v-if="['order', 'coreOrder', 'dividend', 'rewards'].indexOf(type) > -1"
          cols="12"
          md="2"
          class="mt-0 pt-0"
        >
          <v-autocomplete
            v-model="filters.positionType"
            :items="positionTypes"
            :label="$t(`views.common.commonFilters.filter.type.position`)"
            multiple
            small-chips
            deletable-chips
            clearable
            hide-details
            :loading="filtersLoading"
          ></v-autocomplete>
        </v-col>
        <v-col
          v-if="['coreOrder', 'order', 'dividend', 'rewards'].indexOf(type) > -1"
          cols="12"
          md="3"
          class="mt-0 pt-0"
        >
          <v-autocomplete
            v-model="filters.position"
            :items="positions"
            :label="$t('views.common.commonFilters.filter.position')"
            multiple
            small-chips
            deletable-chips
            clearable
            hide-details
            :loading="filtersLoading"
          ></v-autocomplete>
        </v-col>
        <template v-if="(['order', 'dividend', 'coreOrder'].indexOf(type) > -1)">
          <v-col cols="12" md="3" class="mt-0 pt-0 filters-select">
            <TagBox
              ref="tagBox"
              v-model="filters.positionTags"
              group="position"
              :label="$t('views.common.commonFilters.filter.positionTags.label')"
              hideDetails
            />
          </v-col>
        </template>
        <v-col
          v-if="
            hide.indexOf('type') === -1 && ['order', 'coreOrder', 'dividend'].indexOf(type) > -1
          "
          cols="12"
          md="2"
          class="mt-0 pt-0"
        >
          <v-autocomplete
            v-model="filters.type"
            :items="typeTypes"
            :label="$t(`views.common.commonFilters.filter.type.${type}`)"
            multiple
            small-chips
            deletable-chips
            clearable
            hide-details
            :loading="filtersLoading"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="2" class="mt-0 pt-0">
          <v-autocomplete
            v-model="filters.broker"
            :items="brokers"
            :label="$t('views.common.commonFilters.filter.broker')"
            multiple
            small-chips
            deletable-chips
            clearable
            hide-details
            :loading="filtersLoading"
          ></v-autocomplete>
        </v-col>
        <template v-if="['commissionInterest', 'order', 'coreOrder', 'rewards'].indexOf(type) > -1">
          <v-col cols="12" md="3" class="mt-0 pt-0 filters-select">
            <TagBox
              ref="tagBox"
              v-model="filters.tags"
              group="order"
              :label="$t('views.common.commonFilters.filter.tags.label')"
              :hint="$t('views.common.commonFilters.filter.tags.hint')"
              hideDetails
            />
          </v-col>
        </template>
        <template v-if="['order', 'dividend'].indexOf(type) > -1">
          <v-col cols="12" md="2" class="mt-0 pt-0">
            <v-select
              v-model="filters.autoFx"
              :items="autoFxItems"
              hide-details
              :label="$t('views.common.commonFilters.filter.autoFx.label')"
              class="filters-select"
            />
          </v-col>
        </template>
        <template v-if="['commissionInterest'].indexOf(type) > -1">
          <v-col cols="12" md="2" class="mt-0 pt-0">
            <v-select
              v-model="filters.deductible"
              :items="deductibleItems"
              hide-details
              :label="$t('views.common.commonFilters.filter.deductible.label')"
              class="filters-select"
            />
          </v-col>
        </template>
        <v-col cols="12" md="2" class="mt-0 pt-2">
          <v-btn
            class="elevation-0 button-show-filters"
            :class="{ 'black--text': !$vuetify.theme.dark, 'white--text': $vuetify.theme.dark }"
            small
            :color="$vuetify.theme.dark ? 'dark_backgroundLighterBlack' : 'softBackgroundGrey'"
            @click="clearFilters"
          >
            <span>
              {{ $t('views.common.commonFilters.clearFilters') }}
            </span>
            <v-icon class="ml-2" size="20">
              mdi-filter-remove-outline
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'
import { pickBy, sortBy } from 'lodash'
import { getPositionsLean, getBrokers } from '@/lib/api.js'
import { getDateUserFormat } from '@/lib/utils/date.js'
import { getPositionTypes, getPositionText } from '@/lib/positions/positions.js'
import TagBox from '@/views/components/common/TagBox'

export default {
  components: { TagBox },
  props: {
    type: {
      type: String,
      required: true,
    },
    section: {
      type: String,
      default: null,
    },
    hide: {
      type: Array,
      default: () => [],
    },
    showAllTimeFilter: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    filters: {},
    positions: null,
    brokers: null,
    showFilters: false,
    dateSelected: 'last12Months',
    dateMenu: false,
    dates: [],
    filtersLoading: false,
  }),
  computed: {
    ...mapGetters(['isAdminOrTesterRoleUser']),
    mdAndDown() {
      return this.$vuetify.breakpoint.mdAndDown
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs
    },
    dateFilters() {
      return ['last12Months', 'thisYear', 'lastYear', 'thisMonth', 'lastMonth', 'all', 'custom']
        .filter((value) => {
          return value !== 'all' || this.showAllTimeFilter
        })
        .map((value) => {
          return {
            text: this.$t(`views.common.commonFilters.${value}`),
            value,
          }
        })
    },
    positionTypes() {
      return getPositionTypes({ model: 'position' })
        .map((elem) => {
          return {
            text: this.$t(`common.positionTypes.${elem}`),
            value: elem,
          }
        })
        .filter((item) => {
          return ['cfd'].indexOf(item.value) === -1 || this.isAdminOrTesterRoleUser
        })
    },
    orderTypes() {
      return [
        {
          text: this.$t('views.common.commonFilters.filter.orderTypes.buy'),
          value: 'buy',
        },
        {
          text: this.$t('views.common.commonFilters.filter.orderTypes.sell'),
          value: 'sell',
        },
        {
          text: this.$t('views.common.commonFilters.filter.orderTypes.switch'),
          value: 'switch',
        },
        {
          text: this.$t('views.common.commonFilters.filter.orderTypes.switchBuy'),
          value: 'switchBuy',
        },
        {
          text: this.$t('views.common.commonFilters.filter.orderTypes.spinOff'),
          value: 'spinOff',
        },
        {
          text: this.$t('views.common.commonFilters.filter.orderTypes.spinOffBuy'),
          value: 'spinOffBuy',
        },
        {
          text: this.$t('views.common.commonFilters.filter.orderTypes.sharePremium'),
          value: 'sharePremium',
        },
        {
          text: this.$t('views.common.commonFilters.filter.orderTypes.capitalIncrease'),
          value: 'capitalIncrease',
        },
        {
          text: this.$t('views.common.commonFilters.filter.orderTypes.scrip'),
          value: 'scrip',
        },
        {
          text: this.$t('views.common.commonFilters.filter.orderTypes.bonus'),
          value: 'bonus',
        },
        {
          text: this.$t('views.common.commonFilters.filter.orderTypes.stakeReward'),
          value: 'stakeReward',
        },
        {
          text: this.$t('views.common.commonFilters.filter.orderTypes.optionBuy'),
          value: 'optionBuy',
        },
        {
          text: this.$t('views.common.commonFilters.filter.orderTypes.optionSell'),
          value: 'optionSell',
        },
        {
          text: this.$t('views.common.commonFilters.filter.orderTypes.drip'),
          value: 'drip',
        },
        {
          text: this.$t('views.common.commonFilters.filter.orderTypes.deposit'),
          value: 'deposit',
        },
        {
          text: this.$t('views.common.commonFilters.filter.orderTypes.withdrawal'),
          value: 'withdrawal',
        },
        {
          text: this.$t('views.common.commonFilters.filter.orderTypes.brokerTransfer'),
          value: 'brokerTransfer',
        },
        {
          text: this.$t('views.common.commonFilters.filter.orderTypes.commission'),
          value: 'commission',
        },
        {
          text: this.$t('views.common.commonFilters.filter.orderTypes.paidInterest'),
          value: 'paidInterest',
        },
        {
          text: this.$t('views.common.commonFilters.filter.orderTypes.interest'),
          value: 'interest',
        },
        {
          text: this.$t('views.common.commonFilters.filter.orderTypes.interestRetention'),
          value: 'interestRetention',
        },
        {
          text: this.$t('views.common.commonFilters.filter.orderTypes.split'),
          value: 'split',
        },
      ]
    },
    coreOrderTypes() {
      return [
        {
          text: this.$t('views.common.commonFilters.filter.orderTypes.buy'),
          value: 'buy',
        },
        {
          text: this.$t('views.common.commonFilters.filter.orderTypes.sell'),
          value: 'sell',
        },
      ]
    },
    commissionInterestTypes() {
      return [
        {
          text: this.$t('views.common.commonFilters.filter.commissionInterestTypes.commission'),
          value: 'commission',
        },
        {
          text: this.$t('views.common.commonFilters.filter.commissionInterestTypes.paidInterest'),
          value: 'paidInterest',
        },
        {
          text: this.$t('views.common.commonFilters.filter.commissionInterestTypes.interest'),
          value: 'interest',
        },
      ]
    },
    dividendTypes() {
      return [
        {
          value: 'stockDividend',
          text: this.$t('views.common.commonFilters.filter.dividendTypes.stockDividend'),
        },
        {
          value: 'coupon',
          text: this.$t('views.common.commonFilters.filter.dividendTypes.coupon'),
        },
      ]
    },
    typeTypes() {
      if (this.type === 'order') {
        return this.orderTypes
      } else if (this.type === 'coreOrder') {
        return this.coreOrderTypes
      } else if (this.type === 'dividend') {
        return this.dividendTypes
      } else if (this.type === 'commissionInterest') {
        return this.commissionInterestTypes
      }
      return []
    },
    deductibleItems() {
      return [
        {
          text: this.$t('views.common.commonFilters.filter.deductible.all'),
          value: null,
        },
        {
          text: this.$t('views.common.commonFilters.filter.deductible.deductible'),
          value: { $ne: false },
        },
        {
          text: this.$t('views.common.commonFilters.filter.deductible.notDeductible'),
          value: false,
        },
      ]
    },
    autoFxItems() {
      return [
        {
          text: this.$t('views.common.commonFilters.filter.autoFx.all'),
          value: null,
        },
        {
          text: this.$t('views.common.commonFilters.filter.autoFx.yes'),
          value: true,
        },
        {
          text: this.$t('views.common.commonFilters.filter.autoFx.no'),
          value: false,
        },
      ]
    },
    dateRangeText() {
      if (!this.dates || !this.dates.length) return ''
      return this.dates.map((date) => getDateUserFormat(date)).join(' - ')
    },
    filtersNumber() {
      let number = 0
      Object.keys(this.filters).forEach((key) => {
        if (key !== 'date' && this.filters[key] !== null) {
          number++
        }
      })
      return number
    },
    filtersCleaned() {
      return (
        JSON.stringify(this.filters) ===
          JSON.stringify({
            date: {
              $gte: DateTime.fromISO(this.dates[0]).startOf('day').toISO(),
              $lte: DateTime.fromISO(this.dates[1]).endOf('day').toISO(),
            },
          }) && this.dateSelected === 'last12Months'
      )
    },
  },
  watch: {
    filters: {
      handler() {
        if (!Object.keys(this.filters).length) return
        const filterElements = pickBy(
          this.filters,
          (filter) =>
            (filter || filter === false) &&
            (filter.length ||
              filter === true ||
              filter === false ||
              (Object.keys(filter) && Object.keys(filter).length))
        ) // delete empty filters
        filterElements.tags = { $in: filterElements.tags }
        this.$emit('filterElements', filterElements)
      },
      deep: true,
      immediate: true,
    },
    dateSelected: {
      async handler() {
        const dt = DateTime.now()

        if (this.dateSelected === 'last12Months') {
          const start = dt.minus({ year: 1 }).startOf('month').toFormat('yyyy-MM-dd')
          const end = dt.plus({ month: 1 }).endOf('month').toFormat('yyyy-MM-dd')
          this.$set(this, 'dates', [start, end])
        }
        if (this.dateSelected === 'thisYear') {
          const thisYearStart = dt.startOf('year').toFormat('yyyy-MM-dd')
          const thisYearEnd = dt.endOf('year').toFormat('yyyy-MM-dd')
          this.$set(this, 'dates', [thisYearStart, thisYearEnd])
        }
        if (this.dateSelected === 'lastYear') {
          const lastYearStart = dt.minus({ years: 1 }).startOf('year').toFormat('yyyy-MM-dd')
          const lastYearEnd = dt.minus({ years: 1 }).endOf('year').toFormat('yyyy-MM-dd')
          this.$set(this, 'dates', [lastYearStart, lastYearEnd])
        }
        if (this.dateSelected === 'thisMonth') {
          const thisMonthStart = dt.startOf('month').toFormat('yyyy-MM-dd')
          const thisMonthEnd = dt.endOf('month').toFormat('yyyy-MM-dd')
          this.$set(this, 'dates', [thisMonthStart, thisMonthEnd])
        }
        if (this.dateSelected === 'lastMonth') {
          const lastMonthStart = dt.minus({ months: 1 }).startOf('month').toFormat('yyyy-MM-dd')
          const lastMonthEnd = dt.minus({ months: 1 }).endOf('month').toFormat('yyyy-MM-dd')
          this.$set(this, 'dates', [lastMonthStart, lastMonthEnd])
        }
        if (this.dateSelected === 'all') {
          this.dates = []
          this.$set(this.filters, 'date', {})
        }
        if (this.dateSelected === 'custom') {
          if (this.showFilters === false) await this.openFilters()
        }
      },
      immediate: true,
      deep: true,
    },
    dates: {
      handler() {
        if (this.dates.length < 2) return
        if (this.dates[0] > this.dates[1]) {
          this.$set(this, 'dates', [this.dates[1]])
          return
        }

        const gte = DateTime.fromISO(this.dates[0]).startOf('day')
        const lte = DateTime.fromISO(this.dates[1]).endOf('day')

        if (!this.showAllTimeFilter) {
          const rangeDays = lte.diff(gte, ['days']).days
          if (rangeDays > 426) {
            // one year and 2 months max (para que funcione 12 ult months)
            this.$root.$snackbar.error({
              text: this.$t('views.common.commonFilters.filter.smallerRange'),
            })
            return
          }
        }

        this.$set(this.filters, 'date', {
          $gte: gte.toISO(),
          $lte: lte.toISO(),
        })
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // clearDateRange() {
    //   this.$set(this, 'dateSelected', 'all')
    // },
    async updateFilters() {
      this.filtersLoading = true
      const positions = await getPositionsLean()
      this.positions = sortBy(
        positions.data.map((position) => {
          return {
            text: getPositionText(position),
            value: position._id,
          }
        }),
        ['text']
      )
      const brokers = await getBrokers()
      this.brokers = brokers.data.map((broker) => {
        return {
          text: broker.alias,
          value: broker._id,
        }
      })
      this.filtersLoading = false
    },
    async openFilters() {
      this.$set(this.filters, 'deductible', null)
      this.showFilters = true
      await this.updateFilters()
    },
    clearFilters() {
      // si cambia esto, echar un ojo a la computed filtersCleaned

      this.$set(this, 'filters', {})
      this.$set(this, 'dateSelected', 'last12Months')

      this.$set(this.filters, 'date', {
        $gte: DateTime.fromISO(this.dates[0]).startOf('day').toISO(),
        $lte: DateTime.fromISO(this.dates[1]).endOf('day').toISO(),
      })
    },
    async toggleFilters() {
      if (this.showFilters) {
        this.showFilters = false
      } else {
        await this.openFilters()
      }
    },
  },
}
</script>

<style lang="scss">
.theme--dark {
  #common-filters {
    background-color: #1e1e1e;
    .common-filters-header {
      .button-show-filters {
        color: white;
      }
    }
  }
}

#common-filters {
  background-color: white;
  .common-filters-header {
    &.items-flex {
      display: flex;
      justify-content: space-between;
    }
    .filters-flex {
      display: flex;
      align-items: center;
    }
    .button-show-filters {
      margin-top: 1px;
      color: #1f1f1f;
      // height: 33px;
    }
  }

  .filters-row {
    align-items: flex-end;
  }

  .v-select__selections {
    margin-bottom: 6px !important; // igualar la altura de los autocomplete a los v-select
  }
  .filters-select {
    .v-select__selections {
      margin-bottom: 0px !important; // igualar la altura de los autocomplete a los v-select
    }
  }

  .common-filters-add-button {
    &.slot-flex {
      display: flex;
      align-items: center;
    }
  }
}
</style>
